/**
 * Site-wide contact constants.
 *
 * Single source of truth for phone numbers, hours, and labels so a future
 * number change is a one-line edit. Used by the footer, hero CTA "or call"
 * lines, the Discovery Call sidebar, the floating Call pill, and the
 * contact page.
 *
 * To change any of these values: edit here, redeploy. Nothing else.
 */

// E.164 format — used in `tel:` href attributes.
export const FRONT_DESK_PHONE_RAW = '+18626930177';

// Human-readable display format — used in visible text.
export const FRONT_DESK_PHONE_DISPLAY = '862-693-0177';

// Friendly label — shown anywhere we mention the number.
export const FRONT_DESK_LABEL = 'Apex Front Desk';

// Operating hours for the front desk — distinct from Coach Lewis's
// direct/appointment hours.
export const FRONT_DESK_HOURS = 'Mon–Fri 9a–5p ET';

// Pre-built `tel:` href (avoids inline string concatenation everywhere).
export const FRONT_DESK_TEL_HREF = `tel:${FRONT_DESK_PHONE_RAW}`;
